import SearchableSelectableTable from '../adminComponents/searchabletable';
import client from '../../../../../API';

const cols = [
  { key: 'email',              label: 'Email' },
  { key: 'last_campaign_name', label: 'Last Campaign' },
  { key: 'last_campaign_date', label: 'Campaign Date' },
];

export default function SharedWithTable(props) {
  return (
    <SearchableSelectableTable
      queryFn={client.users.fetchSharedWith}
      columns={cols}
      {...props}
    />
  );
}
